import React, { useEffect } from "react";
import { useFieldArray } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import classes from "./SingleDatesWidget.module.scss";

interface SingleDate {
  date: string | null;
  when: Array<{
    timestart: string | null;
    timeend: string | null;
  }>;
  id: string;
}

interface SingleDatesWidgetProps {
  formMethods: any;
  namespace: string;
  hideWhenStatus?: boolean;
}

const generateDefaultEvent = (): SingleDate => ({
  date: null,
  when: [{ timestart: null, timeend: null }],
  id: uuidv4(),
});

const SingleDatesWidget: React.FC<SingleDatesWidgetProps> = ({
  formMethods,
  namespace,
  hideWhenStatus,
}) => {
  const { control } = formMethods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: namespace,
    keyName: "id",
  });

  useEffect(() => {
    if (!(fields && fields.length > 0)) {
      append(generateDefaultEvent());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.singleDatesWidget}>
      <div className={classes.tableScroller}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((field, index) => (
              <tr key={field.id}>
                <td>
                  <input
                    type="date"
                    {...formMethods.register(`${namespace}[${index}].date`)}
                  />
                </td>
                <td>
                  <input
                    type="time"
                    {...formMethods.register(
                      `${namespace}[${index}].when[0].timestart`,
                    )}
                  />
                </td>
                <td>
                  <input
                    type="time"
                    {...formMethods.register(
                      `${namespace}[${index}].when[0].timeend`,
                    )}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className={classes.button}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        onClick={() => append(generateDefaultEvent())}
        className={classes.addButton}
      >
        Add Date
      </button>
    </div>
  );
};

export default SingleDatesWidget;
